import React from 'react';
import i18n from './i18n';

const LanguageSwitcher = ({
    className
}) => {
  const changeLanguage = (lang) => {
    localStorage.setItem('page-lang', lang);
    i18n.changeLanguage(lang); 
    window.location.reload();
  };

  return (
    <>
      <button 
      onClick={() => changeLanguage((localStorage.getItem('page-lang') === "ar") ? "en" : "ar")}
      className={className}
      >
        {(!localStorage.getItem('page-lang') || localStorage.getItem('page-lang')==="en")? "العربية" : "EN"}
      </button>
    </>
  );
};

export default LanguageSwitcher;
